/**
 * Payload for tuningInsight when comparing two runs (suspension-only narrative).
 */

export function buildCompareSuspensionInsightPayload(nameA, sliceA, nameB, sliceB) {
  return {
    task: 'compare_two_suspension_runs',
    instructions: [
      'Compare these two mountain bike suspension runs using ONLY the JSON below.',
      'Do NOT discuss ride duration, distance, TSS, average speed, or general fitness.',
      'Focus on: front/rear balance, dynamic sag, max travel %, bottom-outs, top-outs, packing index/rating, roughness (harshness), and any Jack stroke/velocity stats provided.',
      'Give a concise overview (2–4 short paragraphs or bullet groups) of the most relevant differences and what changed meaningfully between Run A and Run B.',
      'If a metric is missing for one run, say so briefly; do not invent numbers.',
    ].join(' '),
    runA: { runName: nameA, ...sliceA },
    runB: { runName: nameB, ...sliceB },
  };
}
